<template>
  <column-item class="product-action-column-btn"
               :disabled="disabled"
               :type="type"
               :round="round"
               @click="handleClick"
  >
    <div class="container">
      <ym-badge class="badge"
                v-if="save && save > 0"
                :text="`省${save}`"
      />
      <price v-if="showPrice"
             :price="price"
             :type="priceType"
             size="medium"
      />
      <div class="hint"
           :class="{
               'with-price': showPrice,
           }"
      >
        {{ text }}
      </div>
    </div>
  </column-item>
</template>

<script>
  import { Badge } from '@ymba/ym-ui';
  import ColumnItem from '@/components/YmTabbarItem/Column';
  import Price from '@/components/Price';

  export default {
    name: 'ProductDetailBottomActionColumnBtn',
    components: {
      ColumnItem,
      Price,
      YmBadge: Badge,
    },
    props: {
      type: {
        type: String,
        validator(val) {
          return [
            'secondary',
            'primary',
            'gradient-primary',
            'black-gold',
            'gold-black',
            'gradient-training',
          ].includes(val);
        },
        default: 'gradient-primary',
      },
      text: {
        type: String,
        required: true,
      },
      price: {
        type: [Number, String],
        required: true,
      },
      save: {
        type: [String, Number],
      },
      showPrice: {
        type: Boolean,
        default: true,
      },
      round: Boolean,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      priceType() {
        const priceTypeMap = {
          primary: 'primary-bar',
          'gradient-primary': 'primary-bar',
          secondary: 'primary',
          'gold-black': 'black',
          'black-gold': 'gold',
        };
        return priceTypeMap[this.type];
      },
    },
    methods: {
      handleClick() {
        this.$emit('click');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-action-column-btn {
    line-height: 1;
  }

  .container {
    position: relative;
    text-align: center;
  }

  .badge {
    white-space: nowrap;
    position: absolute;
    left: 100%;
  }

  .hint {
    font-size: @font-size-medium;

    &.with-price {
      margin-top: @size-extra-small;
      font-size: @font-size-small;
    }
  }
</style>
